import { Text } from "north.js";
import React from "react";

import globalConstants from "src/theme/globalConstants";

import { TIMELINE_FIELDS } from "./constants";
import { TimelineSection, TimelineGrid, TimelineItem } from "./styles";
import { TTimelineProps } from "./types";
import { formatDate } from "./utils";

const Timeline: React.FC<TTimelineProps> = ({ requestData }) => {
  const timelineEntries = TIMELINE_FIELDS.flatMap(({ key, label }) => {
    const dateValue = requestData[key as keyof typeof requestData];
    if (!dateValue || typeof dateValue !== "string") return [];
    return [{ key, label, dateValue }];
  }).sort(
    (a, b) => new Date(a.dateValue).getTime() - new Date(b.dateValue).getTime()
  );

  if (timelineEntries.length === 0) {
    return null;
  }

  return (
    <TimelineSection>
      <Text
        type="body2"
        style={{
          color: globalConstants?.color?.textSecondary as string,
          fontWeight: 600,
          marginBottom: "8px",
        }}
      >
        Request Timeline:
      </Text>
      <TimelineGrid>
        {timelineEntries.map(({ key, label, dateValue }) => (
          <TimelineItem key={key}>
            <Text
              type="body2"
              style={{
                color: globalConstants?.color?.textSecondary as string,
                minWidth: "80px",
              }}
            >
              {label}:
            </Text>
            <Text type="body2" style={{ fontWeight: 600 }}>
              {formatDate(dateValue)}
            </Text>
          </TimelineItem>
        ))}
      </TimelineGrid>
    </TimelineSection>
  );
};

export default Timeline;
